import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Card, Form, Input, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { LoadingOutlined } from '@ant-design/icons';

export default function AccountSettings({
  loading,
  pending,
  settings,
  onSave,
}) {
  const { t } = useTranslation();
  const [readMode, setReadMode] = useState(true);
  const [form] = Form.useForm();

  const values = useMemo(
    () => ({
      email: settings.email,
    }),
    [settings]
  );

  const handleChangeMode = useCallback(() => {
    setReadMode(!readMode);
  }, [readMode]);

  const handleSave = useCallback(
    (values) => {
      onSave(values, () => handleChangeMode());
    },
    [onSave, handleChangeMode]
  );

  useEffect(() => {
    form.setFieldsValue(values);
  }, [values]);

  return (
    <Card className="settings-card" title={t('account')} bordered={false}>
      <Spin spinning={loading} indicator={<LoadingOutlined />}>
        <Form
          form={form}
          layout="vertical"
          name="account-settings-edit"
          onFinish={handleSave}
        >
          <Form.Item name="email" label={t('email-placeholder')}>
            <Input disabled={readMode} />
          </Form.Item>
          <Form.Item name="password" label={t('password-placeholder')}>
            <Input.Password disabled={readMode} />
          </Form.Item>
          {!readMode ? (
            <Button htmlType="submit" type="default" loading={pending}>
              {t('save')}
            </Button>
          ) : null}
        </Form>
        {readMode ? (
          <Button type="default" onClick={handleChangeMode}>
            {t('change-password')}
          </Button>
        ) : null}
      </Spin>
    </Card>
  );
}
